import { Flex } from "grid-styled";
import styled from "styled-components";

export const ExpanderLabel = styled.span`
  cursor: pointer;
`;

export const ExpanderContainer = styled(Flex)<{ $primary?: boolean }>`
  color: ${({ theme: { palette }, $primary }) => ($primary ? palette.primary : palette.textSecondary)};
  font-size: 0.75rem;
  align-items: center;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;
